(()=>{
 const drawer=document.getElementById('g-minicart');if(!drawer)return;
 const content=drawer.querySelector('[data-g-minicart-content]');
 const root=(window.Shopify?.routes?.root||'/').replace(/\/?$/,'/');
 let busy=false,opener,codButton;
 async function render(){
  content.setAttribute('aria-busy','true');
  try{
   const response=await fetch(root+'cart?section_id=glow-cart&g_promo=1',{credentials:'same-origin',cache:'no-store',headers:{Accept:'text/html'}});
   if(!response.ok)throw Error();
   const doc=new DOMParser().parseFromString(await response.text(),'text/html');
   const cart=doc.querySelector('#g-cart-content');if(!cart)throw Error();
   cart.querySelectorAll('.g-express,.g-cart-discount,.g-section-title,.g-product-grid').forEach(el=>el.remove());
   const shipping=cart.querySelector('.g-shipping-message');
   if(shipping)cart.querySelector('.g-cart-layout')?.prepend(shipping);
   const note=cart.querySelector('.g-cart-note');
   if(note)cart.querySelector('.g-checkout')?.before(note);
   const cod=content.querySelector('._rsi-buy-now-button-cart')||codButton;
   if(cod)codButton=cod;
   if(cod)cod.remove();
   content.replaceChildren(...cart.childNodes);
   if(cod)content.querySelector('.g-checkout')?.after(cod);
   const count=doc.querySelector('[data-g-count]')?.textContent;
   if(count!=null)document.querySelectorAll('[data-g-count]').forEach(el=>el.textContent=count);
  }catch{content.innerHTML='<p>Non è stato possibile caricare il carrello.</p><button type="button" class="g-button" data-g-cart-retry>Riprova</button>';}
  finally{content.removeAttribute('aria-busy');}
 }
 drawer.addEventListener('glow:open',render);
 drawer.addEventListener('close',()=>opener?.focus());
 document.addEventListener('click',event=>{
  const a=event.target.closest('a[href]');if(!a||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
  const url=new URL(a.href,location.href);
  if(url.origin===location.origin&&url.pathname.replace(/\/$/,'')===(root+'cart').replace(/\/$/,'')){
   opener=a;a.dataset.gOpen='g-minicart';
  }
 },true);
 async function change(item,quantity){
  if(busy)return;busy=true;content.setAttribute('aria-busy','true');
  try{
   const response=await fetch(root+'cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:item.dataset.gKey,quantity:Math.max(0,quantity)})});
   const data=await response.json();if(!response.ok)throw Error(data.description||'Impossibile aggiornare il carrello.');
   await render();document.dispatchEvent(new CustomEvent('glow:cart-updated',{detail:data}));
  }catch(error){const alert=content.querySelector('.g-cart-error');if(alert)alert.textContent=error.message;}
  finally{busy=false;content.removeAttribute('aria-busy');}
 }
 drawer.addEventListener('click',event=>{
  if(event.target.closest('#_rsi-buy-now-button')){drawer.close();document.documentElement.style.overflow='';}
  const qty=event.target.closest('[data-g-qty]');if(qty){event.preventDefault();event.stopPropagation();change(qty.closest('[data-g-key]'),Number(qty.dataset.gQty));}
  if(event.target.closest('[data-g-cart-retry]'))render();
 });
 drawer.addEventListener('change',event=>{const input=event.target.closest('.g-quantity input');if(input){event.stopPropagation();const q=Number(input.value);if(Number.isInteger(q)&&q>=0)change(input.closest('[data-g-key]'),q);}});
 drawer.addEventListener('submit',async event=>{
  if(event.submitter?.name!=='update')return;
  event.preventDefault();if(busy)return;busy=true;
  try{const response=await fetch(root+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({note:event.target.elements.note?.value||''})});if(!response.ok)throw Error();await render();}catch{const alert=content.querySelector('.g-cart-error');if(alert)alert.textContent='Impossibile salvare la nota. Riprova.';}finally{busy=false;}
 });
})();
